import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Form, Dropdown } from "react-bootstrap";
import Checkbox from "../../../shared/inputs/Checkbox";
import { useForm } from "react-hook-form";
import {
  UserActivityAxios,
  ProgramSetupAxios,
  OnboardingAxios,
} from "../../../API";
import solutionSlice from "../../../store/Gallery/solutionSlice";
import { useHistory } from "react-router";
import Moment from "react-moment";
import authSlice from "../../../store/auth/authSlice";
import CdxModal from "../../../shared/modal/CdxModal";
import CommentInput from "../../../shared/inputs/CommentInput";
import GradientButton from "../../../shared/inputs/GradientButton";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { forEach } from "lodash";
import Loader from "../../../shared/Loader";
import MultiSelect from "../../../shared/inputs/MultiSelect";

const animatedComponents = makeAnimated();

const Submit = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isReadyForReview, setIsReadyForReview] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [submitSolution, setSubmitSolution] = useState(false);
  const [attachmentErrorText, setAttachmentErrorText] = useState("");
  const [thumbnailName, setThumbnailName] = useState("");
  const [thumbnailErrorText, setThumbnailErrorText] = useState("");
  const [submitType, setSubmitType] = useState("");
  const [attachmentList, setAttachmentList] = useState([]);
  const [attachmentPathList, setAttachmentPathList] = useState([]);
  const [conflictSolution, setConflictSolution] = useState([]);
  const [conflictSolutionModel, setConflictSolutionModel] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const offeringUserId = useSelector(
    (state) => state.auth.loggedInUser.offeringUserId
  );
  const userDetails = useSelector((state) => state.auth.loggedInUser);
  const allActivities = useSelector((state) => state.auth.missionDetails.tasks);
  // const stageActivities = useSelector(
  //   (state) => state.journeyMapSlice.stageActivities
  // );
  const [solutionData, setSolutionData] = useState();
  const [solutionBriefDescription, setSolutionBriefDescription] = useState("");
  const [solutionDescription, setSolutionDescription] = useState("");
  let messagePoint = { ...useSelector((state) => state.auth.messagePoint) };

  const [teamMembers, setTeamMembers] = useState([]);
  const [solutionTags, setSolutionTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setIsLoading(true);
    OnboardingAxios.get(
      "OfferingUsers/getmyteamconnections/" + userDetails.offeringUserId
    )
      .then(function (response) {
        if (response.data.length > 0) {
          setTeamMembers(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    if (userDetails.solutionId != undefined && userDetails.solutionId !== 0) {
      getSolutionById(userDetails.solutionId.id !== undefined ? userDetails.solutionId.id : userDetails.solutionId);
    } else {
      UserActivityAxios.get(
        `/Solution/getsolutionlistbyofferingid/${userDetails.offeringId}/${userDetails.missionId}/${userDetails.offeringUserId}/1/100/0/0`
      )
        .then(function (response) {
          let data = [];
          if (response.data.length > 0) {

            var mySolution = response.data.find(x => x.teamId == userDetails.teamId);
            if (mySolution) {
              getSolutionById(mySolution.id);
              dispatch(authSlice.actions.setSolutionId(mySolution.id));
              setIsLoading(false);

            }
            else {
              dispatch(authSlice.actions.setSolutionId(0));
              setIsLoading(false);
            }

          }
          setIsLoading(false);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
    setValue("teamName", userDetails.teamName);
    getSolutionTagsByOfferingId();
  }, []);


  const getSolutionById = (solutionId) => {
    setConflictSolutionModel(false);
    setAttachmentPathList([]);
    UserActivityAxios.get(
      "/Solution/getsolutionbyid/" +
      solutionId +
      "/" +
      userDetails.offeringUserId
    )
      .then(function (response) {
        setIsLoading(false);
        if (response.data.teamId == userDetails.teamId) {

          let data = response.data;
          setSolutionData(data);
          setValue("solutionName", data.solutionName);
          setValue("teamName", userDetails.teamName);
          setValue("solutionBrief", data.shortDescription);
          setValue("solutionDescription", data.longDescription);
          setSolutionBriefDescription(data.shortDescription);
          setSolutionDescription(data.longDescription);
          setIsReadyForReview(data.readyForReview);
          if (data.solutionFiles.filter((x) => x.fileType === 2).length > 0) {
            setThumbnailName(
              data.solutionFiles.filter((x) => x.fileType === 2)[0].fileName
            );
            setThumbnailFile(
              data.solutionFiles.filter((x) => x.fileType === 2)[0]
            );
          }
          let solutionFiles = [];
          if (data.solutionFiles.length > 0) {
            data.solutionFiles.forEach((element) => {
              if (element.fileType === 1) {
                solutionFiles.push(element);
              }
            });
          }

          // var tempSolutionTags = [];
          // data.solutionTags?.forEach(element => {
          //   tempSolutionTags.push({
          //     label: element.tagName,
          //     value: element.id
          //   });
          // });

          // setSelectedTags(tempSolutionTags);
          setAttachmentList(solutionFiles);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getSolutionTagsByOfferingId = () => {
    ProgramSetupAxios.get(
      "/SolutionTag/getsolutiontags/" + userDetails.offeringId
    )
      .then(function (response) {
        let tagsList = response.data.map((item) => {
          return {
            label: item.tagName,
            value: item.id,
          };
        });
        tagsList = tagsList.sort((a, b) => (a.label > b.label ? 1 : -1));
        setSolutionTags(tagsList);

        //set overall best is default 
        var overallBest = tagsList.filter(x => x.label == "Overall Best");
        setSelectedTags(overallBest);

      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleCheckBoxClick = (event) => {
    setIsReadyForReview(event.target.checked);
  };

  const upload = () => {
    document.getElementById("selectAttachments").click();
  };

  const uploadThumbnail = () => {
    document.getElementById("selectThumbnail").click();
  };

  const [thumbnailFile, setThumbnailFile] = useState(null);
  const thumbnailSelectHandler = async (file) => {
    var allowedExtensions =
      /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.gif|\.GIF|\.png|\.PNG|\.xlsx|\.xls|\.XLSX|\.XLS|\.pdf|\.PDF|\.doc|\.DOC|\.docx|\.DOCX|\.pptx|\.PPTX|\.ppt|\.PPT|\.zip|\.ZIP|\.txt|\.TXT|\.svg|\.SVG)$/;
    if (file.target.value != "" && !allowedExtensions.exec(file.target.value)) {
      file.target.value = null;
      return;
    }

    let currentFile = Array.from(file.target.files);
    if (currentFile && currentFile.length > 0) {
      if (!currentFile[0].type.includes("image")) {
        setThumbnailErrorText(
          "Only image files less than 2MB size are supported"
        );
        return;
      }
      const fileSize = Math.round(currentFile[0].size / 1024);
      if (fileSize >= 2049) {
        setThumbnailErrorText("Thumbnail size exceeds the max limit of 2MB.");
        return;
      } else {
        setThumbnailErrorText("");
      }

      const tmpindex = attachmentPathList.indexOf(thumbnailFile);
      let tmpfiles = [...attachmentPathList];
      if (tmpindex > -1) {
        tmpfiles.splice(tmpindex, 1);
        setAttachmentPathList(tmpfiles);
      }
      var newFormData = new FormData();
      if (solutionData && solutionData.id) {
        newFormData.append("solutionId", solutionData.id);
        newFormData.append("fileName", currentFile[0].name);
        newFormData.append("fileType", 2);
        newFormData.append("mimeType", currentFile[0].type);
      } else {
        newFormData.append("solutionId", 0);
      }
      newFormData.append("file", currentFile[0]);

      setThumbnailName(currentFile[0].name);
      setThumbnailFile(currentFile[0]);
      UserActivityAxios.put("/Solution/uploadsolutionfile", newFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          let item = {
            fileName: currentFile[0].name,
            filePath: response.data,
            fileType: 2,
            mimeType: currentFile[0].type,
            solutionId: 0,
          };
          let tempAttachmentPathList = [];
          tempAttachmentPathList.push(item);
          setAttachmentPathList([
            ...attachmentPathList,
            ...tempAttachmentPathList,
          ]);
        })
        .catch(function (error) {
          console.log(error);
          setThumbnailErrorText(
            "There was an error while uploading the file. Please ensure that you are uploading files from your local computer. Files from Cloud sources like OneDrive or files containing assets embedded from external sites cannot be uploaded."
          );
        });
    }
  };

  const [isUploadProgress, setUploadProgress] = useState(false);
  const fileSelectHandler = async (file) => {
    var allowedExtensions =
      /(\.jpg|\.JPG|\.jpeg|\.JPEG|\.gif|\.GIF|\.png|\.PNG|\.xlsx|\.xls|\.XLSX|\.XLS|\.pdf|\.PDF|\.doc|\.DOC|\.docx|\.DOCX|\.pptx|\.PPTX|\.ppt|\.PPT|\.zip|\.ZIP|\.txt|\.TXT|\.svg|\.SVG)$/;
    if (file.target.value != "" && !allowedExtensions.exec(file.target.value)) {
      file.target.value = null;
      return;
    }

    let currentFile = Array.from(file.target.files);
    if (currentFile && currentFile.length > 0) {
      const fileSize = Math.round(currentFile[0].size / 1024);
      if (fileSize >= (10241 * 2.5)) {
        setAttachmentErrorText("File size exceeds the max limit of 25MB.");
        return;
      }
      else {
        setAttachmentErrorText("");
      }

      let item = {
        fileName: currentFile[0].name,
        fileType: 1,
        filePath: "",
        mimeType: currentFile[0].type,
        solutionId: 0,
        isUploadProgress: true
      };

      let tempAttachmentPathList = JSON.parse(JSON.stringify(attachmentPathList));
      tempAttachmentPathList.push(item);
      setAttachmentPathList(tempAttachmentPathList);
      var newFormData = new FormData();
      if (solutionData && solutionData.id) {
        newFormData.append("solutionId", solutionData.id);
        newFormData.append("fileName", currentFile[0].name);
        newFormData.append("fileType", 1);
        newFormData.append("mimeType", currentFile[0].type);
      } else {
        newFormData.append("solutionId", 0);
      }
      newFormData.append("file", currentFile[0]);
      setUploadProgress(true);
      UserActivityAxios.put("/Solution/uploadsolutionfile", newFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          // let item = {
          //   fileName: currentFile[0].name,
          //   filePath: response.data,
          //   fileType: 1,
          //   mimeType: currentFile[0].type,
          //   solutionId: 0,
          // };

          if (solutionData && solutionData.id) {
            getSolutionById(solutionData.id);
            setAttachmentPathList([]);
          }
          else {
            if (tempAttachmentPathList.filter(x => x.isUploadProgress == true).length > 0) {
              //let tempAttachmentPathList = JSON.parse(JSON.stringify(attachmentPathList));
              tempAttachmentPathList.filter(x => x.isUploadProgress == true)[0]['filePath'] = response.data;
              tempAttachmentPathList.filter(x => x.isUploadProgress == true)[0]['isUploadProgress'] = false;
              setAttachmentPathList(tempAttachmentPathList);
            }
          }
          setUploadProgress(false);
        })
        .catch(function (error) {
          setAttachmentErrorText(
            "There was an error while uploading the file. Please ensure that you are uploading files from your local computer. Files from Cloud sources like OneDrive or files containing assets embedded from external sites cannot be uploaded."
          );
          let tempAttachmentPathList = JSON.parse(JSON.stringify(attachmentPathList));
          if (tempAttachmentPathList.filter(x => x.isUploadProgress == true).length > 0) {
            let index = tempAttachmentPathList.indexOf(tempAttachmentPathList.filter(x => x.isUploadProgress == true)[0]);
            if (index !== -1) {
              tempAttachmentPathList.splice(index, 1);
            }
          }
          setAttachmentPathList(tempAttachmentPathList);
          setUploadProgress(false);
          console.log(error);
        });
    }
  };

  const [deletedFiles, setDeletedFiles] = useState([]);
  const [deletedAttachment, setDeletedAttachment] = useState(null);
  const removeFile = (item) => {
    const index = attachmentList.indexOf(item);
    let files = [...attachmentList];
    const tmpindex = attachmentPathList.indexOf(item);
    let tmpfiles = [...attachmentPathList];

    if (item.id) {
      //setDeletedFiles([...deletedFiles, item.id]);
      setDeletedAttachment(item);
      setModalVisible(true);
    } else {
      if (index > -1) {
        files.splice(index, 1);
        setAttachmentList(files);
      }

      if (tmpindex > -1) {
        tmpfiles.splice(tmpindex, 1);
        setAttachmentPathList(tmpfiles);
      }
    }
  };

  const downloadFile = (item) => {
    console.log(item);
    window.open(item.filePath, "_blank").focus();
  };

  const downloadThumbnail = () => {
    window.open(thumbnailFile.filePath, "_blank").focus();
  };

  const deleteSolutionAttachment = () => {
    if (deletedAttachment) {
      UserActivityAxios.put(
        "/Solution/deletesolutionfile/" + deletedAttachment.id
      )
        .then(function (response) {
          setModalVisible(false);
          const index = attachmentList.indexOf(deletedAttachment);
          let files = [...attachmentList];
          if (index > -1) {
            files.splice(index, 1);
            setAttachmentList(files);
          }
          const tmpindex = attachmentPathList.indexOf(deletedAttachment);
          let tmpfiles = [...attachmentPathList];
          if (tmpindex > -1) {
            tmpfiles.splice(index, 1);
            setAttachmentPathList(tmpfiles);
          }
          setDeletedAttachment(null);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const saveSolution = (data) => {
    //let solutionObj = data;

    if (
      submitType != "" &&
      attachmentList.length == 0 &&
      attachmentPathList.filter(x => x.fileType == 1).length == 0
    ) {
      return;
    }

    if (submitType != "" && solutionDescription == "") {
      return;
    }

    if (submitType != "" && selectedTags.length == 0) {
      return;
    }

    var selectedTagsId = [];
    selectedTags.forEach(element => {
      selectedTagsId.push(element.value);
    });

    setSubmitSolution(true);
    let isSubmitted = false;
    if (submitType === "submit") {
      isSubmitted = true;
    }
    if (userDetails.solutionId !== undefined && userDetails.solutionId !== 0) {
      var newFormData = new FormData();

      newFormData.set("id", userDetails.solutionId.id !== undefined ? userDetails.solutionId.id : userDetails.solutionId);
      newFormData.set("offeringId", userDetails.offeringId);
      newFormData.set("teamId", userDetails.teamId);
      newFormData.set("teamName", userDetails.teamName);
      newFormData.set("missionId", userDetails.missionId);
      newFormData.set("missionName", userDetails.missionName);
      newFormData.set("solutionName", data.solutionName);
      newFormData.set("shortDescription", data.solutionBrief);
      newFormData.set("longDescription", solutionDescription);
      newFormData.set("readyForReview", isReadyForReview);
      newFormData.set("isSubmitted", isSubmitted);
      newFormData.set(
        "lastUpdatedBy",
        userDetails.firstName + " " + userDetails.lastName
      );
      newFormData.append("messagePointOfferingId", messagePoint.offeringId);
      newFormData.append(
        "messagePointOfferingUserId",
        messagePoint.offeringUserId
      );
      newFormData.append("messagePointConnectionId", messagePoint.connectionId);
      newFormData.append("messagePointActivityId", messagePoint.activityId);
      newFormData.append("messagePointTeamId", messagePoint.teamId);
      newFormData.append("messagePointActionKey", messagePoint.actionKey);
      newFormData.append("messagePointIsBackgroundJob", false);
      newFormData.append("tags", selectedTagsId.join());

      UserActivityAxios.put("/Solution/updatesolution", newFormData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(function (response) {
          var indivisualActivities = allActivities.filter(
            (x) => x.activityTypeId === 4 && x.isComplete == false
          );
          if (isSubmitted === true && indivisualActivities.length > 0) {
            var date = new Date();
            var now_utc = Date.UTC(
              date.getUTCFullYear(),
              date.getUTCMonth(),
              date.getUTCDate(),
              date.getUTCHours(),
              date.getUTCMinutes(),
              date.getUTCSeconds()
            );

            var utcCompletedDate = new Date(now_utc);
            var data = teamMembers.map((item) => {
              return {
                OfferingUserId: item.offeringUserId,
                ActivityId: indivisualActivities[0].activityId,
                IsComplete: true,
                ActivityCompletedBy:
                  userDetails.firstName + " " + userDetails.lastName,
                ActivityCompletedOn: utcCompletedDate,
              };
            });

            data.push({
              OfferingUserId: userDetails.offeringUserId,
              ActivityId: indivisualActivities[0].activityId,
              IsComplete: true,
              ActivityCompletedBy:
                userDetails.firstName + " " + userDetails.lastName,
              ActivityCompletedOn: utcCompletedDate,
            });

            // messagePoint.activityId = indivisualActivities[0].activityId;
            var requestObject = {
              requestModel: data,
              message: messagePoint,
              isBackgroundJob: false,
            };
            UserActivityAxios.put(
              "OfferingUserActivity/updatelearnerdata",
              requestObject
            )
              .then(function (res) {
                ProgramSetupAxios.get(
                  "OfferingMission/getmissionbyid/" +
                  userDetails.missionId +
                  "/" +
                  offeringUserId
                )
                  .then(function (missionReponse) {
                    dispatch(
                      authSlice.actions.setMissionDetails(missionReponse.data)
                    );
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              })
              .catch(function (er) {
                console.log(er);
              });
          }

          if (isSubmitted) {
            //send notification to coach
            // Your team has submitted final solution to the gallery.
            OnboardingAxios.get(
              "OfferingUsers/getmyteamconnections/" + userDetails.offeringUserId
            ).then(function (response) {
              let data = response.data;
              let coach = data.filter((item) => item.roleId === 5);
              var notificationData = [
                {
                  offeringId: userDetails.offeringId,
                  missionId: userDetails.missionId,
                  activityBy: userDetails.offeringUserId,
                  offeringUserId: coach[0].offeringUserId,
                  teamId: userDetails.teamId,
                  notificationText: `Your team has submitted final solution to the gallery.`,
                  actionRoute: JSON.stringify({
                    action: "Submit Solution",
                    solutionId: userDetails.solutionId.id !== undefined ? userDetails.solutionId.id : userDetails.solutionId,
                    teamId: userDetails.teamId,
                    actionText: "View",
                  }),
                },
              ];
              var requestObject = {
                requestModel: notificationData,
                message: messagePoint,
                isBackgroundJob: false,
              };
              UserActivityAxios.post(
                "Notification/sendnotifications",
                requestObject
              )
                .then(function (res) { })
                .catch(function (er) {
                  console.log(er);
                });
            });
          }
          //     setDeletedFiles([]);

          setSubmitSolution(false);
          if (isSubmitted) history.push("/gallery");

          // UserActivityAxios.get(
          //   "/Solution/getsolutionlistbyofferingid/" +
          //   userDetails.offeringId +
          //   "/0/" +
          //   userDetails.offeringUserId +
          //   "/1/1000/0/0"
          // )
          //   .then(function (response) {
          //     setDeletedFiles([]);
          //     dispatch(solutionSlice.actions.setSolutionSlice(response.data));
          //     setSubmitSolution(false);

          //     if (isSubmitted) history.push("/gallery");
          //   })
          //   .catch(function (error) {
          //     console.log(error);
          //   });
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      var newFormData = new FormData();

      newFormData.set("offeringId", userDetails.offeringId);
      newFormData.set("teamId", userDetails.teamId);
      newFormData.set("teamName", userDetails.teamName);
      newFormData.set("missionId", userDetails.missionId);
      newFormData.set("missionName", userDetails.missionName);
      newFormData.set("solutionName", data.solutionName);
      newFormData.set("shortDescription", data.solutionBrief);
      newFormData.set("longDescription", solutionDescription);
      newFormData.set("readyForReview", isReadyForReview);
      newFormData.set("isSubmitted", isSubmitted);
      newFormData.set(
        "lastUpdatedBy",
        userDetails.firstName + " " + userDetails.lastName
      );
      // Array.from(attachmentList).forEach((image) => {
      //   newFormData.append("files", image);
      // });
      // newFormData.append("thumbnail", thumbnailFile);
      newFormData.append("uploadedFiles", JSON.stringify(attachmentPathList));
      ProgramSetupAxios.get(
        "OfferingRatings/offeringoverallrating/" + userDetails.offeringId
      )
        .then(function (overallRating) {
          newFormData.set("maxRating", overallRating.data.maxRating);

          newFormData.append("messagePointOfferingId", messagePoint.offeringId);
          newFormData.append(
            "messagePointOfferingUserId",
            messagePoint.offeringUserId
          );
          newFormData.append(
            "messagePointConnectionId",
            messagePoint.connectionId
          );
          newFormData.append("messagePointActivityId", messagePoint.activityId);
          newFormData.append("messagePointTeamId", messagePoint.teamId);
          newFormData.append("messagePointActionKey", messagePoint.actionKey);
          newFormData.append("messagePointIsBackgroundJob", false);
          newFormData.append("tags", selectedTagsId.join());

          UserActivityAxios.post("/Solution", newFormData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
            .then(function (response) {
              if (response.data.isPresent) {
                setConflictSolution(response.data);
                setSubmitType("");
                setSubmitSolution(false);
                setConflictSolutionModel(true);
              } else {
                getSolutionById(response.data.id);
                dispatch(authSlice.actions.setSolutionId(response.data.id));

                var indivisualActivities = allActivities.filter(
                  (x) => x.activityTypeId === 4 && x.isComplete === false
                );
                if (isSubmitted === true && indivisualActivities.length > 0) {
                  var date = new Date();
                  var now_utc = Date.UTC(
                    date.getUTCFullYear(),
                    date.getUTCMonth(),
                    date.getUTCDate(),
                    date.getUTCHours(),
                    date.getUTCMinutes(),
                    date.getUTCSeconds()
                  );

                  var utcCompletedDate = new Date(now_utc);
                  var data = teamMembers.map((item) => {
                    return {
                      OfferingUserId: item.offeringUserId,
                      ActivityId: indivisualActivities[0].activityId,
                      IsComplete: true,
                      ActivityCompletedBy:
                        userDetails.firstName + " " + userDetails.lastName,
                      ActivityCompletedOn: utcCompletedDate,
                    };
                  });

                  data.push({
                    OfferingUserId: userDetails.offeringUserId,
                    ActivityId: indivisualActivities[0].activityId,
                    IsComplete: true,
                    ActivityCompletedBy:
                      userDetails.firstName + " " + userDetails.lastName,
                    ActivityCompletedOn: utcCompletedDate,
                  });

                  data.push({
                    OfferingUserId: userDetails.offeringUserId,
                    ActivityId: indivisualActivities[0].activityId,
                    IsComplete: true,
                    ActivityCompletedBy:
                      userDetails.firstName + " " + userDetails.lastName,
                    ActivityCompletedOn: utcCompletedDate,
                  });
                  // messagePoint.activityId = indivisualActivities[0].activityId;
                  var requestObject = {
                    requestModel: data,
                    message: messagePoint,
                    isBackgroundJob: false,
                  };
                  UserActivityAxios.put(
                    "OfferingUserActivity/updatelearnerdata",
                    requestObject
                  )
                    .then(function (res) {
                      ProgramSetupAxios.get(
                        "OfferingMission/getmissionbyid/" +
                        userDetails.missionId +
                        "/" +
                        offeringUserId
                      )
                        .then(function (missionReponse) {
                          dispatch(
                            authSlice.actions.setMissionDetails(
                              missionReponse.data
                            )
                          );
                        })
                        .catch(function (error) {
                          console.log(error);
                        });
                    })
                    .catch(function (er) {
                      console.log(er);
                    });
                }
                setSubmitSolution(false);
                if (isSubmitted) history.push("/gallery");
                // UserActivityAxios.get(
                //   "/Solution/getsolutionlistbyofferingid/" +
                //   userDetails.offeringId +
                //   "/0/" +
                //   userDetails.offeringUserId +
                //   "/1/100/0/0"
                // )
                //   .then(function (response) {
                //     dispatch(
                //       solutionSlice.actions.setSolutionSlice(response.data)
                //     );
                //     setSubmitSolution(false);

                //     if (isSubmitted) history.push("/gallery");
                //   })
                //   .catch(function (error) {
                //     console.log(error);
                //   });
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(function (er) {
          console.log(er);
        });
    }
  };

  const handleSolutionDescription = (event) => {
    setSolutionDescription(event.target.value);
  };

  const getTruncatedFileName = (name, limit) => {
    let split = name.split('.');
    let filename = split[0].substring(0, limit);
    let extension = split[1];
    return filename + '....' + extension;
  };

  const removeTag = (tagToRemove) => {
    var tempTags = JSON.parse(JSON.stringify(selectedTags));
    tempTags = tempTags.filter(tag => tag.value != tagToRemove.value);
    setSelectedTags(tempTags);
  };


  return (
    <>
      {isLoading ? <Loader loading={true} />
        : <div className="submitTabContainer">
          <form
            onSubmit={handleSubmit(saveSolution)}
            className={userDetails.roleId === 5 ? "disableSubmitForm" : ""}
          >
            {userDetails.roleId === 4 && (
              <div className="ActionBtns">
                <span style={{ marginRight: "20px" }}>
                  <Checkbox
                    checked={isReadyForReview}
                    onChange={handleCheckBoxClick}
                    label="Ready for Review by Mission Director"
                  />
                </span>

                {
                  <>
                    {(solutionData === undefined ||
                      solutionData?.isSubmitted === undefined ||
                      solutionData?.isSubmitted === false) &&
                      submitSolution && (
                        <>
                          <span>
                            <button
                              type="button"
                              style={{ cursor: "default" }}
                              className="submitDraftSolutionBtn"
                            >
                              Save Draft{" "}
                              {submitType == "draft" && (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              )}
                            </button>
                          </span>
                          <span>
                            <button
                              type="button"
                              style={{ cursor: "default" }}
                              className="submitSolutionBtn"
                            >
                              Submit to Gallery{" "}
                              {submitType == "submit" && (
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              )}
                            </button>
                          </span>
                        </>
                      )}
                    {(solutionData === undefined ||
                      solutionData?.isSubmitted === undefined ||
                      solutionData?.isSubmitted === false) &&
                      !submitSolution && (
                        <>
                          {!isUploadProgress && <>
                            <span>
                              <button
                                type="submit"
                                onClick={() => setSubmitType("draft")}
                              >
                                Save Draft
                              </button>
                            </span>
                            <span>
                              <button
                                type="submit"
                                onClick={() => setSubmitType("submit")}
                              >
                                Submit to Gallery
                              </button>
                            </span>
                          </>}
                          {isUploadProgress && <>
                            <span>
                              <button
                                type="submit"
                                // onClick={() => setSubmitType("draft")}
                                disabled={true}
                                className="submitBtnDisabled"
                              >
                                Save Draft
                              </button>
                            </span>
                            <span>
                              <button
                                type="submit"
                                // onClick={() => setSubmitType("submit")}
                                disabled={true}
                                className="submitBtnDisabled"
                              >
                                Submit to Gallery
                              </button>
                            </span>
                          </>}
                        </>
                      )}
                    {solutionData?.isSubmitted === true && !submitSolution && (
                      <span>
                        {!isUploadProgress &&
                          <button
                            type="submit"
                            style={{ cursor: "pointer" }}
                            className="submitSolutionBtn"
                            onClick={() => setSubmitType("submit")}
                          >
                            Update in Gallery{" "}
                          </button>
                        }
                        {isUploadProgress &&
                          <button
                            type="submit"
                            style={{ cursor: "default" }}
                            className="submitSolutionBtn submitBtnDisabled"
                            disabled={true}
                          // onClick={() => setSubmitType("submit")}
                          >
                            Update in Gallery{" "}
                          </button>
                        }
                      </span>
                    )}
                    {solutionData?.isSubmitted === true && submitSolution && (
                      <span>
                        <button
                          type="button"
                          style={{ cursor: "pointer" }}
                          className="submitSolutionBtn"
                        >
                          Update in Gallery{" "}
                          {submitType == "submit" && (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          )}
                        </button>
                      </span>
                    )}
                  </>
                }
              </div>
            )}
            {userDetails.roleId === 5 && (
              <div className="warningTextWrapper">
                {!isReadyForReview && (
                  <>
                    <span className="warningSVG"></span>{" "}
                    <span className="warningText">
                      The solution is not yet marked as ready for review by you!
                    </span>
                  </>
                )}
                {isReadyForReview && (
                  <>
                    <span className="questionSVG"></span>{" "}
                    <span className="warningText">
                      The solution is ready for review by you!
                    </span>
                  </>
                )}
              </div>
            )}

            {userDetails.solutionId != undefined &&
              userDetails.solutionId != 0 &&
              solutionData && (
                <div className="timeStampDiv">
                  Last updated by {solutionData.lastUpdatedBy} on{" "}
                  <Moment add={{ hours: 12 }} format="MM/DD HH:mm A" local={true}>
                    {new Date(solutionData.lastUpdated + "Z")}
                  </Moment>
                </div>
              )}
            <Row className="mt-20">
              <Col>
                <div className="solutionLabel">Solution Name</div>
                <div className="solutionInputBoxDiv">
                  <input
                    type="text"
                    maxLength="50"
                    {...register("solutionName", {
                      required: true,
                    })}
                  />
                </div>
                {errors.solutionName &&
                  errors.solutionName.type === "required" && (
                    <p className="errMsg">Solution Name is required</p>
                  )}
              </Col>

              <Col>
                <div className="solutionLabel">Team Name</div>
                <div className="solutionInputBoxDiv">
                  <input
                    type="text"
                    readOnly="true"
                    maxLength="25"
                    {...register("teamName", {
                      required: true,
                    })}
                  />
                </div>
                {errors.teamName && errors.teamName.type === "required" && (
                  <p className="errMsg">Team Name is required</p>
                )}
              </Col>
            </Row>
            <Row className="mt-20">
              <Col>
                <div className="solutionLabel">Solution Brief</div>
                <div className="solutionTextAreaDiv">
                  <textarea
                    rows="3"
                    maxLength="200"
                    {...register("solutionBrief", {
                      required: true,
                    })}
                    onChange={(e) => {
                      setSolutionBriefDescription(e.currentTarget.value);
                    }}
                  ></textarea>
                  <span className="cdx-char-count">
                    {solutionBriefDescription
                      ? solutionBriefDescription.length
                      : 0}
                    /200
                  </span>
                </div>
                {errors.solutionBrief &&
                  errors.solutionBrief.type === "required" && (
                    <p className="errMsg">
                      Brief Solution description is required
                    </p>
                  )}
              </Col>
            </Row>
            <Row className="mt-20">
              <Col>
                <div className="solutionLabel">
                  Attachments <span>(max size 25MB)</span>
                </div>
                {userDetails.roleId === 4 && (
                  <>
                    {" "}
                    <div
                      className="attachmentDiv"
                      onClick={() => {
                        upload();
                      }}
                    >
                      <span className="attchmentIcon"></span>
                      <span className="attachmentLabel">Select File(s)</span>
                    </div>
                    <input
                      id="selectAttachments"
                      hidden
                      type="file"
                      onChange={fileSelectHandler}
                      accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*,.zip,.docx,.doc,.pptx,.ppt,.xlsx,.xls,.txt,.TXT"
                    />
                    <div className="attachmentErrMsg">{attachmentErrorText}</div>{" "}
                  </>
                )}
                {attachmentList && attachmentList.length > 0 && (
                  <div className="attachmentList">
                    {attachmentList.map((item, index) => {
                      return (
                        <>
                          <div key={index} className="attachmentFile">
                            <Row>
                              {item.solutionId && (
                                <Col md={10} style={{ paddingLeft: "5px" }}>
                                  <span>{item.fileName}</span>
                                </Col>
                              )}
                              {!item.solutionId && (
                                <Col md={10} style={{ paddingLeft: "5px" }}>
                                  <span>{item.name.length > 50 ? getTruncatedFileName(item.name, 40) : item.name}</span>
                                </Col>
                              )}
                              {userDetails.roleId === 4 && (
                                <Col
                                  md={2}
                                  className="pointer"
                                  onClick={() => {
                                    removeFile(item);
                                  }}
                                >
                                  <div className="removeIcon"></div>
                                </Col>
                              )}

                              {userDetails.roleId === 5 && (
                                <Col
                                  md={2}
                                  className="pointer pointer-event"
                                  onClick={() => {
                                    downloadFile(item);
                                  }}
                                >
                                  <div className="downloadIcon"></div>
                                </Col>
                              )}
                            </Row>
                          </div>
                        </>
                      );
                    })}
                  </div>
                )}
                {attachmentPathList && attachmentPathList.length > 0 && (
                  <div className="attachmentList">
                    {attachmentPathList.map((item, index) => {
                      return item.fileType == 1 ? (
                        <>
                          <div key={index} className="attachmentFile">
                            <Row>
                              <Col md={10}>
                                {/* <span>{item.fileName}</span> */}
                                <span>{item.fileName.length > 50 ? getTruncatedFileName(item.fileName, 40) : item.fileName}</span>
                              </Col>
                              {userDetails.roleId === 4 && (
                                <>{(item.isUploadProgress !== undefined && item.isUploadProgress == true) ?
                                  <Col md={2}> <div><span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                    style={{ color: "#00AEFF" }}
                                  ></span></div></Col>
                                  :
                                  <Col
                                    md={2}
                                    className="pointer "
                                    onClick={() => {
                                      removeFile(item);
                                    }}
                                  >
                                    <div className="removeIcon"></div>
                                  </Col>}</>
                              )}
                              {userDetails.roleId === 5 && (
                                <Col
                                  md={2}
                                  className="pointer pointer-event"
                                  onClick={() => {
                                    downloadFile(item);
                                  }}
                                >
                                  <div className="downloadIcon"></div>
                                </Col>
                              )}
                            </Row>
                          </div>
                        </>
                      ) : (
                        <></>
                      );
                    })}
                  </div>
                )}
                {attachmentList &&
                  attachmentList.length == 0 &&
                  attachmentPathList &&
                  attachmentPathList.filter(x => x.fileType == 1).length == 0 &&
                  submitType != "" && (
                    <p className="attachmentErrMsg">
                      Atleast one attachment is required
                    </p>
                  )}

                {attachmentList &&
                  attachmentList.length == 0 &&
                  attachmentPathList &&
                  attachmentPathList.length == 0 &&
                  userDetails.roleId === 5 && (
                    <p className="ms-3">
                      No attachment available
                    </p>
                  )}
              </Col>
            </Row>
            <Row className="mt-20">
              <Col>
                <div className="solutionLabel">Solution Description</div>
                <div className="solutionTextAreaDiv">
                  {/* <textarea
                  rows="3"
                  maxLength="500"
                  {...register("solutionDescription", {
                    required: true,
                  })}
                  onChange={(e) => {
                    setSolutionDescription(e.currentTarget.value);
                  }}
                ></textarea> */}
                  <CommentInput
                    onChange={handleSolutionDescription}
                    value={solutionDescription}
                    inputClassName="assignmentTextBox"
                    id="assignmenttext"
                    name="assignmenttext"
                    className="solutionDescTextarea"
                    isPlaceHolder="false"
                  />
                  {/* <span className="cdx-char-count">
                  {solutionDescription ? solutionDescription.length : 0}/500
                </span> */}
                </div>
                {submitType != "" && solutionDescription == "" && (
                  <p className="errMsg">Solution description is required</p>
                )}
              </Col>
            </Row>
            {/* <Row className="mt-20 mb-5">
              <Col xl={12}>
                <div className="solutionLabel">
                  Award Categories {userDetails.roleId === 4 && <>(Select up to two)*</>}
                </div>

                <div className="tags-container">
                  {userDetails.roleId === 4 &&
                    <>
                      <MultiSelect
                        value={selectedTags}
                        options={solutionTags}
                        onChange={setSelectedTags}
                        maxSelections={2}
                        inputClassName="tag-selection"
                      />

                    </>
                  }

                  {selectedTags.length > 0 && selectedTags.map((tag) => {
                    return (<div key={tag.label} className="tag-container">
                      <>{tag.label}</> {userDetails.roleId === 4 && <div className="tag-close" onClick={() => removeTag(tag)}>X</div>}
                    </div>);
                  })}

                </div>
                {submitType != "" && selectedTags.length == 0 && (
                  <p className="errMsg">Award Category is required</p>
                )}
                <div className="ps-2 learn-more" ><a className="pointer-event" href="https://cdxexplore.deloitte.com/files/Award%20Category%20Framework.pdf" target="blank">Learn more</a> about the award categories.</div>

              </Col>

            </Row> */}
            {((userDetails.roleId === 4) || (thumbnailName != "" && userDetails.roleId === 5)) && <Row className="mt-20">
              <Col>
                <div className="solutionLabel">
                  Thumbnail{" "}
                  <span>(Only image files less than 2MB size are supported)</span>
                </div>
                <div className="thumbnailDiv">
                  <div className="thumbnailElement">
                    <div className="thumbnailItem">{thumbnailName.length > 100 ? getTruncatedFileName(thumbnailName, 90) : thumbnailName}</div>

                    <div className="thumbnailItem push">
                      <span className="thumbnail-vertical-devider"></span>
                      {userDetails.roleId === 4 && (
                        <span
                          className="thumbnail-upload-label"
                          onClick={() => {
                            uploadThumbnail();
                          }}
                        >
                          Select
                        </span>
                      )}
                      <input
                        id="selectThumbnail"
                        hidden
                        type="file"
                        onChange={thumbnailSelectHandler}
                        accept="image/*"
                      />

                      {userDetails.roleId === 5 && (
                        <div className="downloadIcon pointer me-2 ms-1 pointer-event" onClick={() => {
                          downloadThumbnail();
                        }}></div>
                      )}
                    </div>

                  </div>
                </div>
                <div className="attachmentErrMsg">{thumbnailErrorText}</div>
              </Col>

            </Row>
            }

          </form>
        </div>
      }
      <CdxModal
        show={modalVisible}
        onHide={() => setModalVisible(false)}
        onClose={() => setModalVisible(false)}
        backdrop="static"
        noBorder={false}
      >
        <CdxModal.Header>Confirmation</CdxModal.Header>
        <CdxModal.Body>
          Are you sure you want remove this attachment?
        </CdxModal.Body>
        <CdxModal.Footer>
          <button
            className="cdx-btn"
            onClick={() => {
              deleteSolutionAttachment();
            }}
          >
            Yes
          </button>
          <button
            className="cdx-btn"
            onClick={() => {
              setModalVisible(false);
            }}
          >
            Cancel
          </button>
        </CdxModal.Footer>
      </CdxModal>
      <CdxModal
        show={conflictSolutionModel}
        onHide={() => setConflictSolutionModel(false)}
        onClose={() => setConflictSolutionModel(false)}
        className="info-model"
      >
        <CdxModal.Header onClose={() => setConflictSolutionModel(false)}>
          Confirmation
        </CdxModal.Header>
        <CdxModal.Body>
          <div className="">
            It appears that one of your team members has submitted the solution
            while you were filling out the details. Please click Refresh to see
            the submitted solution or click Cancel to stay on this page and copy
            any text that you have typed.
          </div>
          <div className="d-flex justify-content-end ">
            <button
              className="refresh-btn me-2 cdx-btn"
              onClick={() => {
                setConflictSolutionModel(false);
              }}
            >
              Cancel
            </button>
            <button
              className="refresh-btn cdx-btn"
              onClick={() => {
                setAttachmentPathList([]);
                setAttachmentList([]);
                getSolutionById(conflictSolution.id);
              }}
            >
              Refresh
            </button>
          </div>
        </CdxModal.Body>
      </CdxModal>
    </>
  );
};

export default Submit;
